module.exports = __webpack_public_path__ + "static/media/cover.45e9a50e.jpeg";